export default "__VITE_ASSET__mpCktkG2__"